module.exports = __webpack_public_path__ + "static/footer2@3x-a0e794da248ba82e898a07f3412627e8.png";